import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Location from './../models/Location';
import Config from "./../constants/Config"
import { getDummyData } from './../utils/commonUtils';


export function getLocations(params) {
    return new ApiService({
        endpoint: Urls.LOCATION_LIST,
        baseURL: Config.API_HOTEL,
        params: params,
        parser: dataParser,
    }).get()
}

export function getLocation(id) {
    return new ApiService({
        endpoint: `${Urls.LOCATION_DETAIL}/${id}`,
        baseURL: Config.API_HOTEL,
        parser: dataItemParser,
    }).get();
}

export function saveLocation(location) {
    return location && location.id ? new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: `${Urls.LOCATION_DETAIL}/${location.id}`,
        parser: dataItemParser,
    }).put({location: location}) :
    new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.LOCATION_SAVE,
        parser: dataItemParser,
    }).post({location: location});
}


export function deleteLocation(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.LOCATION_DELETE,
        params: params,
        dummy: () => getDummyItem(), //need to remove when api was ready
        parser: dataItemParser,
    }).get();
}


const dataParser = (data) => ({
    // dataList: (data.locations || []).map(item => new Location(item)),
    // pageIndex: Math.floor(data.offset/data.limit) + 1,
    dataList: data.result,
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalCount
});
const dataItemParser = (result) => {
    return new Location(result.location || {})
}
const getDummy = (pageSize = 10, pageIndex = 1) => {
    const getItem = (i) => new Location({
        id: i+1,
        name: 'ĐỊA ĐIỂM ' + (i + 1),
        code: Math.random().toString(36).substring(7).toUpperCase(),
        isActive: i % 2 === 0,
        order: i + 1
    });
    const result = getDummyData(pageSize, pageIndex, getItem);
    return { ...result, dataList: result.data };
}
const getDummyItem = (pageSize = 10, pageIndex = 1) => new Location({
    id: 2,
    name: 'ĐỊA ĐIỂM PAPA',
    code: Math.random().toString(36).substring(7).toUpperCase(),
    isActive: true
});

